import React from 'react';
import estudios from './assets/estudios.jpg';
const EstudiosConexionContent = () => {
  return (
    <div className="containerSer">
      <h2>Estudios de Conexión</h2>
      <p>
        Es un análisis técnico obligatorio que permite evaluar la viabilidad de
        conectar un sistema de generación de energía a la red eléctrica del país
        y así asegurar que esta conexión no afecte negativamente la estabilidad,
        calidad o seguridad del servicio eléctrico prestado por el Operador de
        Red.
      </p>
      <div className='image'> 
       <img src={estudios} alt="Estudios de conexión" />

      </div>
     
      <p>
        Realizamos el estudio requerido para la conexión de tu sistema solar a
        la red eléctrica, llevado a cabo por ingenieros certificados, cumpliendo
        con la normativa vigente y los lineamientos establecidos por el operador
        de red. lo que te permite garantizar una integración segura, eficiente y
        legal de tu sistema fotovoltaico; este servicio te incluye: análisis
        técnico del punto de conexión, evaluación del impacto en la red
        eléctrica; identificación de ajustes o medidas necesarias para la
        conexión, elaboración y presentación del informe técnico ante el
        operador de red; acompañamiento durante la revisión y aprobación del
        estudio.
      </p>
      <h3>Beneficios clave:</h3>
      <ul>
        <li>
          Das cumplimiento a los requisitos legales exigidos para la conexión a
          la red, en los casos aplicables.
        </li>
        <li>Aseguras una instalación confiable.</li>
        <li>Evitas retrasos o rechazos por parte del operador de red.</li>
        <li>
          Obtienes respaldo técnico especializado durante todo el proceso.
        </li>
        <li>
          Tienes la tranquilidad de que tu proceso se llevará a cabo sin
          complicaciones y cumpliendo con los requisitos exigidos.
        </li>
      </ul>
    </div>
  );
};

export default EstudiosConexionContent;
